export const N8nChatTarget = '#n8n-chat';
